import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  TextField,
} from '@mui/material';
import { gql } from 'graphql-request';
import PropTypes from 'prop-types';

import {
  BackButton,
  Error,
  Loading,
  ProductBomForm,
  ViewTitle,
} from '../../../components';
import { app as appConfig } from '../../../configs';
import graphqlClient from '../../../configs/graphqlClient';
import * as actions from '../../../redux/actions';

/**
 * @function CreateBomTemplate
 * @description Display a collections or a list of SettingCreateBOMTemplate from database
 */

export default function CreateBomTemplate({ title, subtitle }) {
  const dispatch = useDispatch();
  const material = useSelector((state) => state.material);
  const history = useHistory();

  const params = useParams();
  const {
    control,
    setValue,
    watch,
    handleSubmit,
    formState: { errors },
  } = useForm({});
  const query = gql`
    query FindSettingEditProductBom($materialInput: MaterialInput) {
      findMaterials(input: $materialInput) {
        total
        rows {
          _id
          name
          type_code
          use_unit_conversion
          unit
          conversion_from {
            unit_a
            unit_b
            conversion_factor
          }
          conversion_to {
            unit_b
            unit_a
            conversion_factor
          }
          unit_input {
            _id
            short_sign
            name
          }
          unit_output {
            _id
            short_sign
            name
          }
        }
      }
    }
  `;

  const queryDataFromServer = async () => {
    try {
      const queryResult = await graphqlClient.request(query, {
        materialInput: {
          page: 1,
          size: appConfig.maxFetchSize,
          fetchStockLot: false,
        },
      });
      const materialData = queryResult?.findMaterials;
      dispatch(actions.materialStateSet(materialData));
    } catch (err) {
      console.error('Material Fetch Error');
      dispatch(actions.materialError());
    }
  };

  useEffect(() => {
    queryDataFromServer();
    return () => {};
  }, [params]);

  const handleCreateBomTemplate = async (data) => {
    try {
      await dispatch(actions.bomTemplateCreate(data));
      alert('สำเร็จ');
      history.goBack();
    } catch (err) {
      alert(`ไม่สามารถสร้างสูตรส่วนผสมได้ ${err?.message}`);
    }
  };

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  if (material.isLoading) {
    return <Loading />;
  }

  if (!material.isLoading && material.isCompleted) {
    return (
      <div>
        {renderTitle()}
        <div className="my-2">
          <BackButton />
        </div>
        <div>
          <Card>
            <CardContent>
              <form onSubmit={handleSubmit(handleCreateBomTemplate)}>
                <div className="w-full px-1 py-2">
                  <Controller
                    control={control}
                    name="name"
                    rules={{ required: true }}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        {...field}
                        label="ชื่อสูตรส่วนผสม"
                        fullWidth
                        required
                        helperText={errors?.name && 'กรุณาใสข้อมูล'}
                      />
                    )}
                  />
                </div>{' '}
                <div className="w-full px-1 py-2">
                  <Controller
                    control={control}
                    name="as_a_batch"
                    render={({ field }) => (
                      <FormControlLabel
                        label="เป็นส่วนผสมต่อ 1 Batch"
                        control={
                          <Checkbox
                            size="small"
                            {...field}
                            defaultChecked={field.value}
                          ></Checkbox>
                        }
                      />
                    )}
                  />
                </div>
                <ProductBomForm
                  control={control}
                  errors={errors}
                  material={material}
                  setValue={setValue}
                  watch={watch}
                  showProduct={false}
                />
                <div className="flex justify-end">
                  <Button variant="contained" type="submit">
                    บันทึก
                  </Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}

CreateBomTemplate.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

CreateBomTemplate.defaultProps = {
  title: '',
  subtitle: '',
};
